// extracted by mini-css-extract-plugin
export default {"NotificationBanner":"Recommendation_NotificationBanner__qBvTD","SuccessIcon":"Recommendation_SuccessIcon__RFxTU","LoadingContainer":"Recommendation_LoadingContainer__oTf5X"};